import { ColourVariation } from 'lib/colourVariation'
import { CategoryDefinitions, CategoryName } from 'types/categoryDefinitions'

export const categoryDefinitions: CategoryDefinitions = {
  'Die 25 besten Winterhotels mit 5 Sternen': {
    colors: new ColourVariation('#a47a00'),
    shortName: '5 Sterne'
  },
  'Die 25 besten Winterhotels mit 4 Sternen': {
    colors: new ColourVariation('#779FBF'),
    shortName: '4 Sterne'
  },
  'Die 25 besten Winterhotels mit 3 Sternen': {
    colors: new ColourVariation('#824e23'),
    shortName: '3 Sterne'
  }
}

export const categoryNames: CategoryName[] = Object.keys(categoryDefinitions)
